import request from '@/shared/api/request';

/**
 *
 * Send an email with the link to set new password.
 *
 * @returns {Promise}
 */
export const resetPassword = (data: { email: string }): Promise<unknown> =>
  request({
    url: '/account/password_reset/',
    method: 'POST',
    data,
  });
